<template>
  <div class="queue-item__detail" :class="classObject" @click="handleClick($event, item.id)">
    <slot></slot>
  </div>
</template>

<script>
  import lodash from 'lodash';

  export default {
    name: 'QueueItemDetail',
    props: {
      item: {
        type: Object,
        default() { return {} },
      },
      hoverable: {
        type: Boolean,
        default: false
      },
      flex: {
        type: Boolean,
        default: false
      },
      classes: {
        type: Array,
        default: function() {
          return [];
        }
      }
    },
    data() {
      return {}
    },
    computed: {
      classObject: function() {
        const initialClasses = {
          'queue-item--flex-container': this.flex,
          'queue-item--hoverable': this.hoverable
        };
        return  lodash.reduce(this.classes, (classes, class_str) => {
          classes[class_str] = true;
          return classes;
        }, initialClasses);
      },
    },
    methods: {
      handleClick(event, id) {
        this.$emit('handle-click', { event: event, id: id });
      }
    },
    watch: {},
    filters: {}
  }
</script>

<style lang="scss" scoped>
  .queue-item {
    @include e(detail) {
      border-left:1px solid $quicksilver;
      padding-top: em(10px);
      padding-bottom:em(10px);
      margin-left:0;
      @include m(first-item) {
        padding-left:em(10px) !important;
        border-left:none;
      }
      @include m(flex-container) {
        display:flex;
        flex-direction:row;
        justify-content:space-around;
      }
    }
  }
  .queue-detail {
    @include m(loader) {
      padding-top:1em;
    }
  }
</style>
